import { render, staticRenderFns } from "./ManageBooking.vue?vue&type=template&id=061227a2"
import script from "./ManageBooking.vue?vue&type=script&lang=js"
export * from "./ManageBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports